import React from 'react';
import TimelineDivider from '../timeline-divider/timeline-divider.js';
import './other-stuff.css';

export default function OtherStuff({ items, companyName }) {
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    return (
        <div className="other-stuff">
            <TimelineDivider />
            <div className="other-stuff__content">
                <h3 className="other-stuff__heading">More at {companyName}</h3>
                <ul className="other-stuff__list">
                    {items.map((item, index) => (
                        <li key={`${item.title}-${index}`} className="other-stuff__item">
                            <span className="other-stuff__item-title">{item.title}</span>
                            {' '}
                            <span className="text-description">{item.body}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
